import Vue from 'vue'

export default new Vue({
    name:'EventBus'
})